import useAuth from '@modules/AuthModule/hooks/useAuth';
import { Button } from '@servicetitan/design-system';
import { useCopyToClipboard } from 'usehooks-ts';

const IdsPanel = () => {
  const auth = useAuth();
  const values = [
    ['User ID', auth.user?.id],
    ['User name', auth.user?.name],
    ['Contact center ID', auth.user?.contactCenterId],
    ['Account ID', auth.user?.accountId],
    ['Org ID', auth.user?.org.id],
    ['Org name', auth.user?.org.name],
  ];
  const copy = useCopyToClipboard()[1];

  return (
    <div>
      <br />
      <Button
        onClick={() =>
          copy(values.map(([key, value]) => `${key}: ${value}`).join('\n'))
        }
        color='primary'
      >
        Copy to clipboard
      </Button>{' '}
      <Button onClick={() => copy(auth.token)}>Copy token</Button>
      <br />
      <br />
      {values.map(([key, value]) => (
        <div key={key}>
          {key}: <pre className='d-i'>{value}</pre>
        </div>
      ))}
    </div>
  );
};

export default IdsPanel;
